var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper flex-center-center"},[_c('article-edit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }